import { Alert, Stack, Text } from '@mantine/core';
import styles from './SaveErrorBox.module.sass';
import type { ErrorResponse } from '@/types/error';
import type { AxiosError } from 'axios';

type SaveErrorBoxProps = {
  error: AxiosError<ErrorResponse> | null;
};

export const SaveErrorBox = ({ error }: SaveErrorBoxProps) => {
  if (!error) {
    return null;
  }

  const errorResponse = error.response?.data;
  const errorMessage = errorResponse?.message ?? '';
  const fieldErrors = errorResponse?.errors ?? [];

  return (
    <Alert color="red" className={styles.errorBox} variant="light">
      <Stack gap={4}>
        <Text size="sm" className={styles.errorTitle}>
          An error occurred:
        </Text>
        {fieldErrors.length === 0 && !errorMessage && <Text size="sm">An unknown error occurred</Text>}
        {errorMessage && <Text size="sm">{errorMessage}</Text>}
        {fieldErrors.map((field) => (
          <Text key={field.property} size="sm">
            {field.property}: {field.messages.join(', ')}
          </Text>
        ))}
      </Stack>
    </Alert>
  );
};
